import React,
{
  useState,
  useEffect,
  Fragment
} from "react";
import { connect } from "react-redux";
import NoRecord from "../../components/NoRecords/noRecords";
import Skeleton from "../../components/vwSkeleton/vwSkeleton"
import {
  closeApprovalActionModal,
  getApprovalsList,
  openApprovalActionModal,
  setAction,
  setPageSizeGlobal,
  setSelectedRequestId
} from "../../store/approvals/actions";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Spinner,
  Table
} from "reactstrap";
import VWModel from "../../components/vwModal/vwModal";
import ApprovalAction from "./ApprovalAction";
import VWPagination from "../../components/vwPagination/vwPagination";
import { getPager } from "../../helper/common";
import Message from "../../CommonData/Data/Message";
import VWLoading from "../../components/vwLoading/vwLoading";
import { SUPER_ADMIN } from "../../store/users/role.constants";
import UITooltip from "../../CommonData/Data/UITooltip";
import moment from 'moment';
import "../FixedColumn.css";

const style = {
  table: {
    width: '100%',
    display: 'table',
    borderSpacing: 0,
    borderCollapse: 'separate',
  },
  th: {
    top: 0,
    left: 0,
    zIndex: 2,
    position: 'sticky',
    backgroundColor: '#fff',
  },
};

const Approvals = (props) => {

  const { approvalList, isGetApprovalsPending, isApprovalActionModalOpen, errorMessage, currentProfile } = props;
  const [pageSize, setPageSize] = useState(10);
  const [pager, setPager] = useState({ currentPage: 1 });
  const [filter, setFilter] = useState({ status: 'pending' });

  const isSuperAdmin = currentProfile.roles && currentProfile.roles.length > 0 &&
    (currentProfile.roles[0].roleKey === SUPER_ADMIN);

  const buildQueryStatus = () => {
    const { status } = filter || {};
    let searchStatus = '';
    if (status) {
      searchStatus += `${status}`;
    }
    return searchStatus
  }

  const setPage = (page = 1) => {
    props.getApprovalsList(page, pageSize, buildQueryStatus(), sortDirection, sortOrder);
    setPager(prevPager => {
      const totalPages = Math.ceil(props.totalRecords / pageSize);
      const visiblePages = 10;
      const pageOffset = Math.max(0, Math.floor((page - 1) / visiblePages) * visiblePages);
      const newPages = [];
      for (let i = pageOffset + 1; i <= Math.min(totalPages, pageOffset + visiblePages); i++) {
        newPages.push(i);
      }
      return {
        ...prevPager,
        currentPage: page,
        totalPages,
        pages: newPages,
      };
    });
  };
  useEffect(() => {
    const currentUpdatePager = getPager(props.totalRecords, 1, pageSize);
    setPager(currentUpdatePager);
  }, [props.totalRecords, pageSize]);

  // useEffect(() => {
  //   const currentPageNo = pager && pager.currentPage;
  //   setPage(currentPageNo);
  // }, []);

  useEffect(() => {
    setPage();
    props.setPageSizeGlobal(pageSize)
  }, [pageSize])

  useEffect(() => {
    if (filter) {
      setPage();
    }
  }, [filter])

  const handleClose = () => {
    const { closeApprovalActionModal } = props;
    closeApprovalActionModal();
  };

  // const [action, setAction] = useState(null);
  //const [selectedRequestId, setSelectedRequestId] = useState(null);

  const handleOpenApprovalAction = (action, requestId) => {
    props.setAction(action);
    props.setSelectedRequestId(requestId);
    props.openApprovalActionModal();
  };

  const [sortDirection, setSortDirection] = useState('asc');
  const [sortOrder, setSortOrder] = useState(null);

  const handleSort = (column) => {
    if (sortOrder === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder(column);
      setSortDirection('asc');
    }
  };
  useEffect(() => {
    if (sortOrder && sortDirection) {
      setPage();
    }
  }, [sortOrder, sortDirection])

  return (
    <Fragment>
      <div className="page-content">
        <Card>
          <CardTitle className="p-2 mb-0 fs-5 fw-bold text-dark d-flex justify-content-between">
            APPROVALS
            <div className="d-flex gap-4 fw-bold">
              <Button
                className='fw-bold'
                size='sm'
                color='info'
                outline
                active={(filter && filter.status) === 'pending'}
                onClick={() => setFilter({ status: 'pending' })}
              >Pending
              </Button>
              <Button
                className='fw-bold'
                size='sm'
                color='primary'
                active={(filter && filter.status) === 'approved'}
                outline
                onClick={() => setFilter({ status: 'approved' })}
              >Approved
              </Button>
              <Button
                className='fw-bold'
                size='sm'
                color='danger'
                active={(filter && filter.status) === 'rejected'}
                outline
                onClick={() => setFilter({ status: 'rejected' })}
              >Rejected
              </Button>
            </div>
          </CardTitle>
        </Card>
        <Card>
          <CardBody>
            {errorMessage && (
              <Message
                type="danger"
                defaultMessage={errorMessage}
                baseClassName="alert"
              />
            )}
            <div style={{ maxHeight: "500px", overflowX: "auto" }}>
              <Table className="table table-striped table-hover table-nowrap w-100" size='sm' style={style.table}>
                <thead className='overflow-hidden sticky-top' style={{ backgroundColor: "white", overflow: "hidden", zIndex: "10" }}>
                  <tr>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('displayName')}>
                      NAME
                      {sortOrder === 'displayName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('roleDisplayName')}>
                      ROLE
                      {sortOrder === 'roleDisplayName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    {isSuperAdmin && <th style={{ cursor: "pointer" }} onClick={() => handleSort('orgName')}>
                      ORGANIZATION
                      {sortOrder === 'orgName' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>}
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('requestor')}>
                      REQUESTOR
                      {sortOrder === 'requestor' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    <th style={{ cursor: "pointer" }} onClick={() => handleSort('status')}>
                      STATUS
                      {sortOrder === 'status' && (
                        <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                      )}
                    </th>
                    {((filter && filter.status) !== 'pending') &&
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedTimeStamp')}>
                        UPDATED ON
                        {sortOrder === 'updatedTimeStamp' && (
                          <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                        )}
                      </th>
                    }
                    {((filter && filter.status) !== 'pending') &&
                      <th style={{ cursor: "pointer" }} onClick={() => handleSort('updatedByEmail')}>
                        UPDATED BY
                        {sortOrder === 'updatedByEmail' && (
                          <i className={`fa fa-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`} />
                        )}
                      </th>}
                    {(!isSuperAdmin && ((filter && filter.status) === 'pending')) &&
                      <th className="text-center sticky-column" style={{ backgroundColor: "white", overflow: "hidden", zIndex: "20" }}>
                        ACTIONS
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {(approvalList && approvalList.length > 0) && !isGetApprovalsPending ?
                    approvalList.map((data, index) => (
                      <tr key={index}>
                        <td>{data.displayName || "NA"} <br />
                          <small>{data.email || "NA"}</small>
                        </td>
                        <td>{data.roleDisplayName || "NA"}</td>
                        {isSuperAdmin &&
                          <td>{data.orgName || "NA"}</td>
                        }
                        <td>
                          {data.requestor || "NA"}<br />
                          <small>{data.requestorEmail || "NA"}</small>
                        </td>
                        <td>
                          {data.status || "NA"}<br />
                        </td>
                        {((filter && filter.status) !== 'pending') &&
                          <td>
                            {data.updatedTimeStamp ? moment(data.updatedTimeStamp).format("DD MMM YYYY") : "NA"}<br />
                          </td>
                        }
                        {((filter && filter.status) !== 'pending') &&
                          <td>
                            {data.updatedByEmail || "NA"}<br />
                          </td>
                        }
                        {(!isSuperAdmin && ((filter && filter.status) === 'pending')) &&
                          <td className="sticky-column bg-white">
                            <UITooltip id="accept" content={"Accept"}>
                              <button
                                type="button"
                                className="me-2 btn btn-sm btn-success"
                                onClick={() =>
                                  handleOpenApprovalAction("approved", data.id)
                                }
                              >
                                <em className="fas fa-user-check"></em>
                              </button>
                            </UITooltip>
                            <UITooltip id="reject" content={"Reject"}>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() =>
                                  handleOpenApprovalAction("rejected", data.id)
                                }
                              >
                                <em className="fas fa-user-times"></em>
                              </button>
                            </UITooltip>
                          </td>}
                      </tr>
                    ))
                    : isGetApprovalsPending ? (
                      <tr>
                        <td colSpan={9} align="center" className="p-4">
                          <Skeleton type="body" />
                          <VWLoading />
                        </td>
                      </tr>
                    ) :
                      <tr>
                        <td colSpan={9}>
                          <NoRecord />
                        </td>
                      </tr>
                  } </tbody>
              </Table>
            </div >
          </CardBody>
          <CardFooter>
            {props.approvalList.length > 0 ?
              <VWPagination
                pager={pager}
                setPage={setPage}
                totalRecords={props.totalRecords}
                pageSize={pageSize}
                setPageSize={setPageSize}
              /> : null
            }
          </CardFooter>
        </Card>
        <VWModel
          header="APPROVAL ACTION"
          isOpen={isApprovalActionModalOpen}
          handleClose={handleClose}
        >
          <ApprovalAction handleClose={handleClose} />
        </VWModel>
      </div>
    </Fragment>
  );
}

const mapStateToProps = (state) => ({
  isApprovalActionModalOpen: state.approvals.isApprovalActionModalOpen,
  approvalList: state.approvals.approvals,
  errorMessage: state.approvals.approvalListError,
  totalRecords: state.approvals.totalRecords,
  isGetApprovalsPending: state.approvals.isGetApprovalsPending,
  currentProfile: state.login.currentProfile,
});

const mapDispatchToProps = (dispatch) => ({
  openApprovalActionModal: () => dispatch(openApprovalActionModal()),
  closeApprovalActionModal: () => dispatch(closeApprovalActionModal()),
  setPageSizeGlobal: (pageSize) => dispatch(setPageSizeGlobal(pageSize)),
  setAction: (action) => dispatch(setAction(action)),
  setSelectedRequestId: (requestId) => dispatch(setSelectedRequestId(requestId)),
  getApprovalsList: (page, pageSize, searchStatus, sortDirection, sortOrder) => dispatch(getApprovalsList(page, pageSize, searchStatus, sortDirection, sortOrder)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Approvals);
